import { createClient } from '@supabase/supabase-js'
import { serverHost } from 'variables/serverdata'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true
  },
  global: {
    headers: {
      'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`
    }
  }
})

export const fetchCompleteUserData = async (userId) => {
  try {
    console.log('fetchCompleteUserData called with userId:', userId);
    
    // First fetch basic user data using direct fetch with proper CORS headers
    const response = await fetch(
      `${process.env.REACT_APP_SUPABASE_URL}/rest/v1/app_user?select=*&user_id=eq.${userId}`,
      {
        method: 'GET',
        headers: {
          'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch user data: ${response.status} ${response.statusText}`);
    }

    const basicUserData = (await response.json())[0];
    
    if (!basicUserData) {
      console.error('No user data found for ID:', userId);
      return null;
    }

    console.log('Basic user data fetched:', basicUserData);

    // Then fetch dealer data if dealer_id exists
    let dealerData = null;
    if (basicUserData.dealer_id) {
      const dealer = await fetch(`${serverHost}/dealer_data`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          dealer_id: basicUserData.dealer_id
        })
      })
      dealerData = dealer.json()
      if (!dealer.ok) {
        console.error('Error fetching dealer data:', dealerData);
      } else {
        console.log('Dealer data fetched:', dealerData);
      }
    }

    // Then fetch client data if client_id exists
    let clientData = null;
    let clientModules = [];
    if (basicUserData.client_id) {
      const client = await fetch(`${serverHost}/client_data`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          client_uuid: basicUserData.client_id
        })
      })
      console.log("dealer fetched:", client)
      if (!client.ok) {
        const clientError = await client.json();
        console.error('Error fetching dealer data:', clientError);
      } else {
        const clientData = await client.json();
        console.log('Client data fetched:', clientData);
      }

      // Fetch client modules
      const { data: modules, error: modulesError } = await supabase
        .from('client_module')
        .select(`
          module_id,
          module:module_id (
            module_id,
            name,
            description
          )
        `)
        .eq('client_id', basicUserData.client_id);

      if (modulesError) {
        console.error('Error fetching client modules:', modulesError);
      } else {
        clientModules = modules?.map(cm => cm.module) || [];
        console.log('Client modules fetched:', clientModules);
        
        // Store client modules in localStorage
        localStorage.setItem('clientModules', JSON.stringify(clientModules));
      }
    }

    // If user has a site_id, fetch site data
    let siteData = null;
    if (basicUserData.site_id) {
      const { data: site, error: siteError } = await supabase
        .from('site')
        .select('site_id, company_name, client_id')
        .eq('site_id', basicUserData.site_id)
        .single();

      if (siteError) {
        console.error('Error fetching site data:', siteError);
      } else {
        siteData = site;
        console.log('Site data fetched:', siteData);
      }
    }

    // Combine all data
    const completeUserData = {
      ...basicUserData,
      dealer: dealerData,
      client: clientData,
      site: siteData,
      clientModules: clientModules
    };

    console.log('Complete user data assembled:', completeUserData);
    return completeUserData;

  } catch (error) {
    console.error('Error in fetchCompleteUserData:', error);
    return null;
  }
}
